import us from 'uScope/js/defines';
import { roundToDecimals } from 'uScope/js/lib/utility/helpers';

const RIGHT_BUTTON = 2;

// ............................................ vp_mousedown
// vp_mousedown - This function handles mousedown and touchstart events for the viewport.
export function vp_mousedown (uScope, viewport, e) {
  viewport.focus(); // force focus on this vp for hot keys
  const annotationsService = viewport.annots;
  if (annotationsService) {
    // hide any hovering note
    annotationsService.regHoverShow(false);
  }

  $(us.idHashROOT).find('.' + us.clsPANELCLICKCLOSE).dialog('close'); // close click-closable panels

  if (e.button === RIGHT_BUTTON) { // on right click (context menu)
    uScope.setImageSelected(viewport.getImageIdx()); // insure this is the selected image
    return; // and return, nothing else to do here
  }

  var cpVpRelPos = us.coordPageToView(e, viewport); // the unrotated viewport relative cursor position

  var navMode = viewport.navModeGet(); // cache nav mode since it can be set inside the switch statement
  if (navMode !== us.eNavModes.nmNone) { // don't compute basePos unless needed
    var basePos = us.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
  }

  switch (navMode) {
    case us.eNavModes.nmNone: // mouse down when no nav mode happening means start of drag image navigation or pinch zoom
      if (e.touches && e.touches.length > 1) {
        // start pinch zoom
        viewport.navModeSwitch(us.eNavModes.nmPinchZoom);
      } else {
        // start drag mode
        viewport.setCursor('move'); // change to move cursor
        viewport.navModeSwitch(us.eNavModes.nmDragImage);
        viewport.setMouseCur(cpVpRelPos.x, cpVpRelPos.y, 'initPrev'); // initialize previous mouse cursor position to this too
      }
      break;
    case us.eNavModes.nmAnnotPin: // start (and finish) drawing the pin, text mouse down when annotate pin, text and report region means set element here
      if (annotationsService) {
        var anType = us.eAnTypes.pin;
        annotationsService.startNew(anType, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
      }
      break;
    case us.eNavModes.nmAnnotText:
      annotationsService.createTextAt(annotationsService, basePos);
      break;
    case us.eNavModes.nmAnnotReport:
      if (annotationsService) {
        annotationsService.startNew(us.eAnTypes.report, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
      }
      break;
    case us.eNavModes.nmAnnotRect: // mousedown for these region types starts drawing
    case us.eNavModes.nmAnnotEllipse:
    case us.eNavModes.nmAnnotPen:
    case us.eNavModes.nmAnnotArrow:
    case us.eNavModes.nmAnnotNegPen:
      if (annotationsService) {
        anType = us.eAnTypes.rect; // cp-could cure this mess with a data structure
        if (navMode === us.eNavModes.nmAnnotEllipse) anType = us.eAnTypes.ellipse;
        else if (navMode === us.eNavModes.nmAnnotArrow) anType = us.eAnTypes.arrow;
        else if (navMode === us.eNavModes.nmAnnotPen) anType = us.eAnTypes.pen;
        else if (navMode === us.eNavModes.nmAnnotNegPen) anType = us.eAnTypes.negpen;
        annotationsService.startNew(anType, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
      }
      break;
    case us.eNavModes.nmAnnotCaliper: // caliper sets new position down on each mousedown
    case us.eNavModes.nmAnnotPolygon: // caliper sets new position down on each mousedown
      if (annotationsService) {
        if (annotationsService.drawingIsStarted()) { // if already drawing, update caliper tool
          annotationsService.updateNew(basePos, 'mousedown');
        } else { // otherwise, start drawing the caliper or polygon
          var type = (navMode == us.eNavModes.nmAnnotCaliper) ? us.eAnTypes.caliper : us.eAnTypes.polygon;
          annotationsService.startNew(type, basePos, viewport.getViewZoom(), viewport.getViewAngle(true));
        }
      }
      break;
    case us.eNavModes.nmRedrawStarting: // start pen redraw mode
      if (annotationsService) {
        if (annotationsService.regReDraw('start', basePos, viewport.getViewZoom())) {
          viewport.navModeSwitch(us.eNavModes.nmRedraw);
        }
      }
      break;
    case us.eNavModes.nmAutoPan: // mouse down when autopanning means stop
    case us.eNavModes.nmRasterScan: // mouse down when rastering means stop
      viewport.navModeHalt();
      break;
    case us.eNavModes.nmZoom:
      // can this happen?
      break;
    default:
  }
}

// ............................................ vp_mousemove
// vp_mousemove - This function dispatches the mousemove and touchmove events.
export function vp_mousemove (uScope, viewport, e) {
  var navMode = viewport.navModeGet();
  var cpVpRelPos = us.coordPageToView(e, viewport); // the unrotated viewport relative cursor position
  var basePos;

  if (uScope.isRegionCopyActive() == true) { // todo: call into a uScope region toolbar fn instead of doing this here...
    var crsrPosBase = us.coordBaseImage(e, viewport); // compute the position of the cursor in base image coords
    var anObj = viewport.annots;
    anObj.regMoveCenter(crsrPosBase);
  }
  switch (navMode) {
    case us.eNavModes.nmDragImage: // mouse move in drag image navigation
      if (e.touches && e.touches.length > 1) { // swiping but two fingers show up, switch out of drag and start pinch zoom
        viewport.navModeSwitch(us.eNavModes.nmPinchZoom); // note - this is very unusual but make pinch initiation more reliable
        return;
      }
      viewport.setMouseCur(cpVpRelPos.x, cpVpRelPos.y);
      var ptDelta = viewport.getMouseCurDiff();
      if (ptDelta.x != 0 || ptDelta.y != 0) { // note that this occurs more than you'd imagine
        viewport.moveRelative(ptDelta.x, ptDelta.y); // move the image dx, dy
      }
      break;
    case us.eNavModes.nmPinchZoom:
      if (viewport.initDist === 0 && e.touches.length > 1) {
        var dx = e.touches[0].clientX - e.touches[1].clientX;
        var dy = e.touches[0].clientY - e.touches[1].clientY;
        viewport.initDist = parseInt(Math.hypot(dx, dy), 10);
        viewport.initMag = viewport.getViewMag();
      } else if (e.touches.length > 1) { // insure two touches, sometimes there is only one!
        dx = e.touches[0].clientX - e.touches[1].clientX;
        dy = e.touches[0].clientY - e.touches[1].clientY;
        var curDist = parseInt(Math.hypot(dx, dy), 10);

        var scale = (1.0 - (viewport.initDist - curDist) / viewport.initDist).toFixed(3);
        var mag = viewport.initMag * scale;
        var zoom = viewport.convertToZoom(mag);
        zoom = roundToDecimals(zoom);
        if (zoom !== viewport.getViewZoom()) {
          viewport.zoomAbsolute(zoom);
        }
      }
      break;

    case us.eNavModes.nmAnnotRect:
    case us.eNavModes.nmAnnotEllipse:
    case us.eNavModes.nmAnnotPen:
    case us.eNavModes.nmAnnotNegPen:
    case us.eNavModes.nmAnnotReport:
    case us.eNavModes.nmAnnotArrow:
      basePos = us.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
      if (viewport.annots) {
        viewport.annots.updateNew(basePos, 'mousemove');
      }
      break;
    case us.eNavModes.nmAnnotPin: // nothing to do on mouse move for pin, text
    case us.eNavModes.nmAnnotText:
      break;
    case us.eNavModes.nmAnnotCaliper:
    case us.eNavModes.nmAnnotPolygon: // caliper sets new position down on each mousedown
      basePos = us.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
      if (viewport.annots) {
        viewport.annots.updateNew(basePos, 'mousemove');
      }
      break;
    case us.eNavModes.nmRedraw: // continue pen redraw
      basePos = us.coordBaseImage2(cpVpRelPos, viewport); // the cursor in base image coords
      anObj = viewport.annots; // the annot object
      if (anObj) {
        if (!anObj.regReDraw('update', basePos, viewport.getViewZoom())) {
          anObj.regReDraw('finish');
        }
      }
      break;
    case us.eNavModes.nmAutoPan:
      //  autopan motion is controlled on a timer but it needs the current mouse position
      viewport.setMouseCur(cpVpRelPos.x, cpVpRelPos.y); // update current mouse position in vp
      break;
    case us.eNavModes.nmRasterScan:
      break;
    case us.eNavModes.nmRotatingOverlay:
      viewport.scaleBar.rotateToCursor(e); // scale bar rotation .. same code in scalebar mousemove
      break;
    default:
  }
};

// ............................................ vp_mouseup
// vp_mouseup - This function dispatches mouse up events that usually indicate either an end to drawing
//                or and end to a nvaigation mode, with a few exceptions.
export function vp_mouseup (uScope, viewport, e) {
  switch (viewport.navModeGet()) {
    case us.eNavModes.nmDragImage:
      if (viewport.isFitZoom() == false) { // if enabled and not fit zoom, finish drag with momentum
        viewport.navModeHalt(); // must halt before drag momentum
        viewport.viewDragMomentumGo();
      } else {
        viewport.navModeHalt();
      }
      break;
    case us.eNavModes.nmThumbDragImage: // thumb mouse up passes thru here
      viewport.navModeHalt();
      break;
    case us.eNavModes.nmZoom:
      break;
    case us.eNavModes.nmPinchZoom:
      viewport.initDist = 0; // reset distance measurement
      viewport.navModeHalt(); // must halt first so that final zoom can use all pyr levels
      break;
    case us.eNavModes.nmAnnotArrow:
    case us.eNavModes.nmAnnotRect:
    case us.eNavModes.nmAnnotEllipse:
    case us.eNavModes.nmAnnotPen:
    case us.eNavModes.nmAnnotNegPen:
    case us.eNavModes.nmAnnotReport: // halt nav mode these drawing tools
      if (viewport.annots) {
        viewport.annots.finishNew();
      }
      viewport.navModeHalt();
      break;
    case us.eNavModes.nmAnnotCaliper: // halt nav mode on mouse leave for caliper but not mouse up
    case us.eNavModes.nmAnnotPolygon: // caliper sets new position down on each mousedown
      if (e.type == 'mouseleave' && viewport.annots) {
        viewport.annots.finishNew();
        viewport.navModeHalt();
      }
      break;
    case us.eNavModes.nmRedraw:
    case us.eNavModes.nmRedrawStarting:
      if (viewport.annots) {
        viewport.annots.regReDraw('finish');
      }
      viewport.navModeHalt();
      break;
    case us.eNavModes.nmAutoPan:
      // if the mouse just rolled over the autopan center target, don't halt nav
      // note: since there can be multiple classNames (space delimited) so string-in-string is performed
      if (e.relatedTarget.className.indexOf(us.clsAPANIMG) === -1) {
        viewport.navModeHalt();
      }
      break;
    case us.eNavModes.nmRasterScan:
      break;
    default:
      viewport.navModeHalt();
  }
}

// ............................................ vp_mousedclick
// vp_mousedclick - This function dispatches mouse double click events.
export function vp_mousedclick (uScope, viewport, e) {
  switch (viewport.navModeGet()) {
    case us.eNavModes.nmNone:
      const crsrPosBase = us.coordBaseImage(e, viewport); // get the position of the cursor in base image coords

      viewport.moveAbsoluteCenter(crsrPosBase.x, crsrPosBase.y); // move image center to the cursor position
      viewport.zoomAbsolute(viewport.getViewPrevZoom()); // and execute the zoom
      break;
    case us.eNavModes.nmAnnotCaliper:
    case us.eNavModes.nmAnnotPolygon:
      const annotationsService = viewport.annots;
      if (annotationsService && annotationsService.drawingIsStarted()) {
        const crsrPosBase = us.coordBaseImage(e, viewport); // compute the position of the cursor in base image coords
        annotationsService.updateNew(crsrPosBase, 'mousedown');
        annotationsService.finishNew();
        viewport.navModeHalt();
      }
      break;
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/hmi/pointerApi.js